// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"908e6669","977":"2d8c05e6"}[chunkId] + ".chunk.js";
};